.container {
  width: 100%;
  border-radius: var(--border-radius-medium);
  border: 1.5px dashed var(--color-secondary);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 1.6rem;
  align-items: center;
  margin-bottom: 0.8rem;
}

.detail {
  font-size: 1.2rem;
  text-align: right;
  color: var(--color-grayscale-light-slate);
}

.wrapper {
  flex: 1;
  max-height: calc(100% - 4.8rem);

  img {
    object-fit: contain;
  }
}
